import { createStore } from 'effector';

export const $investProRegions = createStore([]);
$investProRegions.watch((state) => console.log('$investProRegions', state));

export const $investProStartRegions = createStore([]);
$investProStartRegions.watch((state) =>
  console.log('$investProStartRegions', state)
);

export const $investProStartDistricts = createStore([]);
$investProStartDistricts.watch((state) =>
  console.log('$investProStartDistricts', state)
);

export const $investProDistricts = createStore([]);
$investProDistricts.watch((state) => console.log('$investProDistricts', state));

export const $investProDots = createStore([]);
$investProDots.watch((state) => console.log('$investProDots', state));

export const $investProStartDots = createStore([]);
$investProStartDots.watch((state) => console.log('$investProStartDots', state));

export const $showProjectsTree = createStore(false);
$showProjectsTree.watch((state) => console.log('$showProjectsTree', state));

export const $regionsDict = createStore({});
$regionsDict.watch((state) => console.log('$regionsDict', state));

export const $showRegionsTree = createStore(false);
$showRegionsTree.watch((state) => console.log('$showRegionsTree', state));

export const $regionsLayer = createStore('total_population');

export const $projectModal = createStore(null);

export const $activeModal = createStore(null);

export const $separatedDots = createStore({});
$separatedDots.watch((state) => console.log('$separatedDots', state));

export const $altaRailwayStartDots = createStore([]);
export const $altaRailwayDots = createStore([]);
$altaRailwayDots.watch((state) => console.log('$altaRailwayDots', state));

export const $kzAirportsStartDots = createStore([]);
export const $kzAirportsDots = createStore([]);
$kzAirportsDots.watch((state) => console.log('$kzAirportsDots', state));

export const $kzHelicopterStartDots = createStore([]);
export const $kzHelicopterDots = createStore([]);
$kzHelicopterDots.watch((state) => console.log('$kzHelicopterDots', state));

export const $ferryTerminalsStartDots = createStore([]);
export const $ferryTerminalsDots = createStore([]);
$ferryTerminalsDots.watch((state) => console.log('$ferryTerminalsDots', state));

export const $minresStartPolygons = createStore([]);
export const $minresPolygons = createStore([]);
$minresPolygons.watch((state) => console.log('$minresPolygons', state));

export const $izStartDots = createStore([]);
export const $izDots = createStore([]);
$izDots.watch((state) => console.log('$izDots', state));

export const $sezStartDots = createStore([]);
export const $sezDots = createStore([]);
$sezDots.watch((state) => console.log('$sezDots', state));
export const $sezStartPolygons = createStore([]);
export const $sezPolygons = createStore([]);
$sezPolygons.watch((state) => console.log('$sezPolygons', state));

export const $startHexagons = createStore([]);
export const $hexagons = createStore([]);
$hexagons.watch((state) => console.log('$hexagons', state));

export const $hexProperty = createStore('count_gas_station');

export const $showHeatmap = createStore(false);

export const $kazakhstanPolygon = createStore([]);

export const $popupData = createStore(null);

export const $azsStartPoints = createStore([]);
export const $azsPoints = createStore([]);
$azsPoints.watch((state) => console.log('$azsPoints', state));

export const $warehouseStartPoints = createStore([]);
export const $warehousePoints = createStore([]);
$warehousePoints.watch((state) => console.log('$warehousePoints', state));

export const $stoStartPoints = createStore([]);
export const $stoPoints = createStore([]);
$stoPoints.watch((state) => console.log('$stoPoints', state));

export const $chartsRawData = createStore(null);
$chartsRawData.watch((state) => console.log('$chartsRawData', state));

export const $chartData = createStore(null);
$chartData.watch((state) => console.log('$chartData', state));

export const $roadsInRegions = createStore(null);
$roadsInRegions.watch((state) => console.log('$roadsInRegions', state));
